import { ref } from 'vue'

import apiMenu from '@/api/menu'

import mealsTemplates from './mealsTemplates'
import daysTemplates from './daysTemplates'

export default function ({
  // mealsTemplates params
  applyTemplate = () => {},
  resetTemplate = () => {},
  testShowTemplatesWarningForm = () => {},
  // daysTemplates params
  goal,
  menuType,
  updateDaysTemplateInfo = () => {},
  afterSendingMealsTemplate = () => {},
  afterSendingDaysTemplate = () => {},
  toast = () => {},
}) {
  const {
    mealsTemplate,
    selectedMealsTemplate,
    selectedMealsTemplate2,
    isShowTemplatesWarningForm,
    isShowEmtyTemplatesWarning,
    dontShowTemplatesWarningForm,
    // computed
    // methods
    setShowTemplatesWarningForm,
    setShowEmtyTemplatesWarning,
    setDontShowTemplatesWarningForm,
    confirmMealsTemplate,
    cancelMealsTemplate,
    setMealsTemplate,
    sendMealsTemplate,
  } = mealsTemplates({
    goal,
    menuType,
    applyTemplate,
    resetTemplate,
    testShowTemplatesWarningForm,
    afterSendingMealsTemplate,
  })

  const {
    selectedDaysTemplate,
    selectedDaysTemplate2,
    isShowDaysTemplatesWarningForm,
    daysTemplate,
    // computed
    daysFilterTemplateId,
    // methods
    setDaysTemplate,
    sendDaysTemplate,
    confirmDaysTemplate,
    cancelDaysTemplate,
  } = daysTemplates({
    menuType,
    updateDaysTemplateInfo,
    afterSendingDaysTemplate,
    toast,
  })

  const mealsLoading = ref(false)
  const getTemplates = async (menuType) => {
    let response = null
    mealsLoading.value = true
    dontShowTemplatesWarningForm.value = true
    try {
      response = await apiMenu.getCustomizationInfoFilters(menuType)
      if (response) {
        const { data: { filter: { meals, days } } = {} } = response
        setMealsTemplate(meals)
        setDaysTemplate(days)
      }
    } catch (error) {
      console.log('error', error)
      response = null
      setMealsTemplate()
      setDaysTemplate()
    } finally {
      mealsLoading.value = false
      setTimeout(() => {
        dontShowTemplatesWarningForm.value = false
      }, 0)
    }
  }

  return {
    // index
    // methods
    mealsLoading,
    getTemplates,
    // mealsTemplates
    // data
    mealsTemplate,
    selectedMealsTemplate,
    selectedMealsTemplate2,
    isShowTemplatesWarningForm,
    isShowEmtyTemplatesWarning,
    dontShowTemplatesWarningForm,
    // computed
    // methods
    setShowTemplatesWarningForm,
    setShowEmtyTemplatesWarning,
    setDontShowTemplatesWarningForm,
    confirmMealsTemplate,
    cancelMealsTemplate,
    setMealsTemplate,
    sendMealsTemplate,
    // daysTemplates
    // data
    selectedDaysTemplate,
    selectedDaysTemplate2,
    isShowDaysTemplatesWarningForm,
    daysTemplate,
    // computed
    daysFilterTemplateId,
    // methods
    setDaysTemplate,
    sendDaysTemplate,
    confirmDaysTemplate,
    cancelDaysTemplate,
  }
}
